<mat-dialog-actions *ngIf="openAsDialog">
  <mat-icon svgIcon="close-line" mat-dialog-close style="width: 20px;"></mat-icon>
</mat-dialog-actions>
<fieldset [disabled]="(contractDataService.subContractFormState | async )==='Submitting'">
<app-contract-roadmap-menu 
  *ngIf="contractStatusesToShowRMmenu.includes(contractData?.contract?.contract.status)"
  [contractStatus] = "this.contractData?.contract?.contract.status"
  [isContractInterDomain] = "this.contractFormService.checkContractDomainIsCurrent(this.contractData?.contract.contract)"
  >
</app-contract-roadmap-menu>

<div class="grid-contrainer" >
  <div class="contract-header" >
      <mat-icon svgIcon="home-4-fill"  style="width: 14px;" class="base-icon"
        (click)="returnToContactTable()" data-action="returnToContactTable">
      </mat-icon>
      <div (click)="returnToContactTable()" class="contract-header-name" >{{'MAIN_MENU.MENU_ITEMS.MENU_CONTRACTS'|translate}}</div>
      <mat-icon svgIcon="organization-chart" style="width: 14px;" class="base-icon"
        (click)="goToGraphView()" data-action="goToGraphView">
      </mat-icon>
      <div (click)="goToGraphView()"class="contract-header-name" >
        {{(contractDataService.isGraphShown? 'CONTRACTS.CARD.MAIN_VIEW' : 'CONTRACTS.CARD.GRAPH') | translate}}
      </div>
      <mat-button-toggle-group *ngIf="contractDataService.isGraphShown" class="graph-group" [formControl]="contractGraphType" aria-label="Тип графа">
        <mat-button-toggle class="graph-group-button"  value="line"
          matTooltip="{{'GRAPH.BUTTONS.TOOLTIPS.LINE' | translate}}" >
          {{ 'GRAPH.BUTTONS.LINE' | translate }}
        </mat-button-toggle>
        <mat-button-toggle class="graph-group-button"  value="stairs"       
          matTooltip="{{'GRAPH.BUTTONS.TOOLTIPS.ONE_PAGE' | translate}}" >
            {{ 'GRAPH.BUTTONS.ONE_PAGE' | translate }}
        </mat-button-toggle>
      </mat-button-toggle-group>
  </div>

  <div class="contract-title" *ngIf="this.contractData?.contract">
    <mat-icon  style="cursor: pointer;"
      *ngIf="(titleChanged$ | async)===true && contractData?.rights?.isContractBlockedForEdit  === false" 
      (click)="saveContractName()"
      svgIcon="check-double-fill">
    </mat-icon>
    <input type="text" 
      class="contract-title-name" 
      [class.block-edit]="contractData?.rights?.isContractBlockedForEdit === true"
      [formControl]="contractNameFC">
    <div ></div>
    <div class="contract-title-data">

      <div class="contract-title-data-created" (contextmenu)="switchView()" >
        {{'CONTRACTS.CARD.created_at'| uppercase | translate }} {{' '}}
        {{contractData?.contract?.contract?.created_at | date:'dd.MM.yyyy'}}
        {{' '+('CONTRACTS.CARD.IN'| translate) +' '  }}
        {{contractData?.contract?.contract?.created_at.split(' ')[1]?.split('.')[0]?.slice(0,5)}}
      </div>

      <button (click)="onReloadContract()" data-action="onReloadContract" class="button-icon size-m primary-button" >
        <mat-icon svgIcon="refresh-line"></mat-icon>
        <span> {{'CONTRACTS.BUTTONS.RELOAD'|translate}} </span>
      </button>
      <div class="button-icon size-m outline-button shadow-xl contract-title-data-status" >
         <mat-icon class="accent-icon" [svgIcon]="contractStatusIconMap.get(this.contractData?.contract?.contract.status)||'time-line'" ></mat-icon>
        <span> {{'CONTRACTS.STATUSES_NEW.' + contractData?.contract?.contract?.status | translate}} </span> 
      </div>
      <button (click)="showRoadMapHistoryList()" data-action="showRoadMapHistoryList"
        class="button-icon size-m primary-button contract-title-data-history" 
        [class.history-opened]="contractFormService.showHistoryList" >
        <mat-icon [svgIcon]="contractFormService.showHistoryList? 'close-fill' :'timer-2-line'"> </mat-icon>
        <span>{{'CONTRACTS.CARD.HISTORY'|translate}} </span>
      </button>
    </div>
  </div>

  <app-roadmap-graph *ngIf="contractDataService.isGraphShown && contractData?.contract?.contract"
    [canEdit]="contractData?.rights?.isContractBlockedForEdit === false"
    [contractGuid]="contractData.contract.contract.guid"
    [contractName]="contractData.contract.contract.name"
    [isViewing]="isViewing"
    [newStep]="newStep"
    [projects]="contractData.contract.projects"
    [roadmap]="contractData?.contract?.roadmap_active.steps">
  </app-roadmap-graph>

  <mat-grid-list cols="12" rowHeight="100%" class="contract-grid" [style.visibility]="contractDataService.isGraphShown? 'hidden' : 'visible'">
    <mat-grid-tile colspan="3" >
      <div class="contract-grid-first">
        <div class="contract-actions contract-grid-first-border">
          <div class="contract-actions-first">
            <button   (click)="onSignContract()" data-action="onSignContract"
              *ngIf="contractData?.contract?.contract?.status !== 'verified'"
              class="button-icon size-l primary-button" 
              [disabled]="contractData?.rights?.isContractBlockedForEdit === true||
                          !contractData?.rights.isCurrentMemberSigner||
                          contractDataService.subContractEdited?.value === true||
                          contractData.contractRoadmap?.steps?.length===0
                          ">
              <mat-icon [svgIcon]="contractData?.rights.isUserVerifiedContract? 'arrow-go-back-fill' :'checkbox-fill'"></mat-icon>
              <span>
                {{(contractData?.rights.isUserVerifiedContract? 'CONTRACTS.CARD.RECALL' : 'CONTRACTS.CARD.APPROVE') |translate}}
              </span>
            </button>
            <button  (click)="onRegoniciate()" data-action="onRegoniciate" 
              class="button-icon size-l primary-button" 
              *ngIf="contractData?.contract?.contract?.status === 'verified'" 
              [disabled]="!contractData?.rights.isCurrentMemberSigner||
                          contractDataService.subContractEdited?.value === true||
                          contractData.contractRoadmap?.steps?.length===0">
              <mat-icon svgIcon="file-check-fill"></mat-icon>
              <span>{{'CONTRACTS.CARD.REGONICIATE' |translate}} </span>
            </button>

          </div>
          <div class="contract-actions-second">
            <button (click)="onCloneContract()" data-action="onCloneContract"
              class="button-icon size-l outline-button" style="padding: 0 12px"
              [disabled] = "!this.contractData">
              <mat-icon svgIcon="file-2-fill"> </mat-icon>
              <span> {{'CONTRACTS.CARD.CLONE'|translate}}</span>
            </button>
            <button (click)="deleteContract()" data-action="deleteContract" style="min-width: 52px ; width: 52px;"
              class="button-icon size-l outline-button"
              [disabled]="contractData?.rights?.isContractBlockedForEdit === true||
                          contractData?.rights?.isCurrentMemberInContract === false">
              <mat-icon svgIcon="delete-bin-5-fill"
               [class.disabled]="this.contractData?.rights?.isContractBlockedForEdit === true"> 
              </mat-icon>
            </button>
          </div>
        </div>
        <div class="contract-products contract-grid-first-border">
            <app-contract-block-bank-products></app-contract-block-bank-products>
        </div>
        <div class="contract-finance contract-grid-first-border" *ngIf="this.contractData">
            <app-contract-block-finance 
              [currentMember]="this.contractDataService.currentMember"
              [contractData]="this.contractData"
              [isFinanceBlockAvailable] = "contractData?.rights?.isFinanceBlockAvailable">
            </app-contract-block-finance>
        </div>
        <div class="contract-description contract-grid-first-border">
          <div class="contract-description-title" (click)="showFullContractDesc = !showFullContractDesc">
              {{'CONTRACTS.CARD.CONTRACT_DESC'|translate}}
              <mat-icon  class="black-icon" style="width: 18px;" [svgIcon]="showFullContractDesc? 'arrow-up-s-line' :'arrow-down-s-line'">  </mat-icon>
          </div>
          <div 
            class="contract-description-data" 
            [class.show-full-desc]="showFullContractDesc"
            [innerHtml]="contractData?.contract?.contract.description || 'Добавить описание контракта'"
            (click)="openDescriptionEditor()"
            >
          </div>
        </div>
        <div class="contract-parties contract-grid-first-border">
            <app-contract-parties-block 
              [contractGuid]="contractGuid"
              ></app-contract-parties-block>
        </div>

      </div>
    </mat-grid-tile>

    <mat-grid-tile colspan="6"  >
      <app-component-loading [size]="'inline'" [margin]="'40px'" *ngIf="!contractGuid"></app-component-loading>
      <app-contract-roadmap *ngIf="contractGuid" [contractGuid]="contractGuid"></app-contract-roadmap>
    </mat-grid-tile>

    <mat-grid-tile colspan="3" class="contract-grid-third">
      <app-contract-history-list *ngIf="this.contractFormService.showHistoryList" [contractGuid]="contractGuid"></app-contract-history-list>
      
      <div  *ngIf="selectedStepData?.contractStep">
        <app-contract-step
          [contractStep]="selectedStepData?.contractStep"
          [contractData]="contractData"
          [stepDivData]="selectedStepData?.stepDivData"
        ></app-contract-step>
      </div>

    </mat-grid-tile>
  </mat-grid-list>
</div> 
</fieldset>